import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d4bc80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "letsTalk-block" }
const _hoisted_3 = { class: "content-wrapper wow-total animate__fadeInUp" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-animation" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "safari-fix" }, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.pageData['coloredBorderTitle']), 1),
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.pageData['coloredBorderButtonLink'],
            class: "btn btn-blue btn-letsTalk"
          }, _toDisplayString(_ctx.pageData['coloredBorderButtonText']), 9, _hoisted_8)
        ])
      ])
    ])
  ]))
}